// Add the error handler to the application
export default function registerErrorHandler(app) {
    app.config.errorHandler = err => {
        console.error(err);
        //window.location.href = '/an-error-has-occurred';
    };
}
